export const valueFormated = (pValue: string) => {
  const split = pValue.split('-');
  const split2 = split[1].split('%');
  return Number(split2[0].trim());
};

export const getCssColor = (pValue: string) => {
  switch (pValue) {
    case 'Mauvais':
      return '#FE3123';
    case 'Médiocre':
      return '#FFBF66';
    case 'Moyen':
      return '#FFE0B3';
    case 'Bon':
      return '#BBE8CD';
    default:
      return '#63D1B4';
  }
};

export const dataFormated = (pDataResponse: object[]) => {
  let newData: any[] = [];
  pDataResponse.forEach((line: any, index: number) => {
    const percentage: string = line.percentage;
    if (percentage.charAt(0) !== '0') {
      newData.push({
        x: index,
        y: valueFormated(line.percentage),
        note: line.note,
        color: getCssColor(line.note),
        pourcentage: line.percentage,
      });
    }
  });
  return newData;
};
